import { ErrorMessage, Field, useField } from "formik";
import React, { forwardRef, Fragment } from "react";
import "./css/InputField.css";

type InputFieldProps = {
  as?: string;
  rows?: number;
  id: string;
  name: string;
  type?: string;
  placeholder?: string;
  className?: string;
  icon?: null;
  label?: string;
  parentClass?: string;
  required?: boolean;
  addDefaultClass?: boolean;
  showError?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<any>) => void;
  onClick?: () => void;
  value?: string | number;
  disabled?: boolean;
};

const InputField = forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  InputFieldProps
>(
  (
    {
      as,
      rows,
      id,
      name,
      type = "text",
      placeholder,
      className,
      icon,
      label,
      onKeyDown,
      onChange,
      onClick,
      disabled = false,
      parentClass,
      required,
      addDefaultClass = true,
      showError = true,
    },
    ref
  ) => {
    const [field] = useField(name);

    return (
      <>
        <div className={`w-full relative ${parentClass ?? ""}`}>
          {label && (
            <label htmlFor={id} className="block text-base text-black mb-1.5 pt-2 sm:pt-0 font-medium">
              {label}
              {required && <span className="text-red-500 pl-1">*</span>}
            </label>
          )}
          <Field
            as={as}
            rows={rows}
            id={id}
            name={name}
            type={type}
            placeholder={placeholder}
            data-icon={icon}
            onKeyDown={onKeyDown}
            onClick={onClick}
            disabled={disabled}
            onChange={(e: React.ChangeEvent<any>) => {
              field.onChange(e);
              onChange?.(e);
            }}
            className={
              addDefaultClass
                ? `border border-blackM/10 p-4 rounded-md placeholder:text-darkgray focus:outline-none w-full text-base font-normal leading-[17.6px] bg-white text-black  ring-2 ring-transparent focus:ring-black/10 focus:ring-offset-2 transition-all duration-300 disabled:bg-black/5 disabled:cursor-not-allowed ${
                    className ?? ""
                  }`
                : className ?? ""
            }
            innerRef={ref} // Optional, won't cause error but not necessary
          />
        </div>
        {showError ? (
          <ErrorMessage
            name={name}
            component="div"
            className="text-red-500 text-sm mt-1"
          />
        ) : (
          <Fragment />
        )}
      </>
    );
  }
);

InputField.displayName = "InputField";

export default InputField;
